<template>
    <div>
        <b-card style="width: 100%; margin: 0px; padding: 0px;" no-body>
            <b-card-header class="d-flex justify-content-start justify-content-md-between align-items-center py-2 bg-light">
                <h6 class="mb-0"></h6>
                <div class="d-flex flex-wrap align-items-center gap-3">
                    <!-- Main Schedule Date Control -->
                    <div class="d-flex align-items-center">
                        <label class="mb-0 mr-2 text-nowrap">Schedule Date</label>
                        <date-picker
                            v-model="mainScheduleDate"
                            format="MM-DD-YYYY"
                            valueType="format"
                            placeholder="Select date for all items"
                            class="mr-2 schedule-date-picker"
                        ></date-picker>
                        <!-- <b-button
                            size="sm"
                            variant="outline-primary"
                            @click="applyMainScheduleDate"
                            :disabled="!mainScheduleDate"
                            v-b-tooltip.hover
                            title="Apply this date to all items"
                        >
                            Apply to All
                        </b-button> -->
                    </div>

                    <!-- Main Receiving Location Control -->
                    <div class="ml-0 ml-lg-2 mt-1 mt-lg-0 d-flex flex-wrap flex-lg-nowrap align-items-center">
                        <label class="mb-0 mr-2 text-nowrap">Receiving Location</label>
                        <b-form-select
                            v-model="mainReceivingLocation"
                            :options="packet.locsubs"
                            size="sm"
                            style="font-size: 12px;"
                            class="mr-2 receiving-location-picker"
                        ></b-form-select>
                        <!-- <b-button
                            size="sm"
                            variant="outline-primary"
                            @click="applyMainReceivingLocation"
                            :disabled="!mainReceivingLocation"
                            v-b-tooltip.hover
                            title="Apply this location to all items"
                        >
                            Apply to All
                        </b-button> -->
                    </div>

                    <!-- Apply Both Button -->
                    <!-- <b-button
                        size="sm"
                        variant="primary"
                        @click="applyBothMainSettings"
                        :disabled="!mainScheduleDate || !mainReceivingLocation"
                        v-b-tooltip.hover
                        title="Apply both date and location to all items"
                    >
                        Apply Both
                    </b-button> -->

                    <!-- Auto-apply toggle -->
                    <!-- <div class="form-check ml-3">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            id="autoApplyCheckbox"
                            v-model="autoApplyMainDate"
                        >
                        <label class="form-check-label small" for="autoApplyCheckbox">
                            Auto-apply Date
                        </label>
                    </div> -->
                </div>
            </b-card-header>
            <span v-if="products.length > 0" style="padding: 10px;">

                <b-card-text>
                  <b-card-text v-if="read_only != true">
                        <span v-if="products.length > 0">
                            <vue-simple-suggest
                            v-model="product_search_keyword"
                            display-attribute="product_name"
                            value-attribute="product_sku"
                            :max-suggestions="200"
                            :list="products"
                            :filter-by-query="true"
                            @select="add_item"
                            :filter="filter_products"
                            ref="product_sku"
                            :disabled="packet.userDetails.userrole !== 'admin'"
                            style="margin-bottom: 10px; font-size: 16px; font-family: monospace; border: 1px solid black;"
                            class="input-field"
                            >
                            <div slot="suggestion-item" slot-scope="{ suggestion, autocomplete }">
                                <span>{{ suggestion.product_name }} [{{ suggestion.product_sku }}]</span>
                            </div>
                            </vue-simple-suggest>
                        </span>

                        <span v-else>
                            <b-alert variant="warning" show>
                            NO PRODUCTS AVAILABLE FOR VENDOR: {{ packet.vendorsdict[vendor_id] }}
                            </b-alert>
                        </span>
                        </b-card-text>

                    <div v-if="items.length > 0" class="diver">
                        <b-card-text v-if="items.length > 0">
                            <table class="text-monospace" style="width: 100%;">
                                <thead>
                                    <tr>
                                        <td class="srr" style="width: 100px;">
                                            PRODUCT SKU
                                        </td>
                                        <td class="srr" style="width: 200px;">
                                            DESCRIPTION
                                        </td>
                                        <td class="srr" style="width: 100px;">
                                            COLOR
                                        </td>
                                        <td class="srr" style="width: 60px;">
                                            CUBES
                                        </td>
                                        <td class="srr" style="width: 80px;">
                                            FOB
                                        </td>
                                        <td class="srr" style="width: 80px;">
                                            LANDED
                                        </td>
                                        <td class="srr" style="width: 80px;">
                                            ORDER QTY/RCV QTY
                                        </td>
                                        <td class="srr" style="width: 80px;">
                                            ORDER QTY
                                        </td>
                                        <td class="srr" style="width: 80px;">
                                            SCH QTY
                                        </td>
                                        <td class="srr" style="width: 80px;">
                                            RCV QTY
                                        </td>
                                        <td class="srr" style="width: 100px;">
                                            STATUS
                                        </td>

                                        <td class="srr" style="width: 150px;">
                                            SCH DATE
                                        </td>

                                        <td class="srr" style="width: 150px;">
                                            RECEIVE LOC
                                        </td>

                                        <td class="srr" style="width: 150px;">
                                            RECEIVE DATE
                                        </td>

                                        <td class="srr" style="width: 100px;">
                                            COMMENTS
                                        </td>
                                        <td class="srr" v-if="read_only != true" style="width: 120px;">
                                            ACTION
                                        </td>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="item, idx in items" v-bind:key="idx" :style="{}">
                                        <td class="srrv">
                                            {{ item.product_sku }}
                                        </td>

                                        <td class="srrv">
                                            {{ item.product_name }}
                                        </td>

                                        <td class="srrv">
                                            <div v-if="read_only != true">
                                                <b-form-select :options="colors" v-model="item.color" size="sm" :disabled="isItemDisabled(item)"
                                                    style="font-size: 11px;"></b-form-select>
                                            </div>
                                            <div v-else>
                                                {{ item.color }}
                                            </div>
                                        </td>

                                        <td class="srrv">
                                            {{ item.cubes }}
                                        </td>

                                      <td class="srrv" :class="{'has-error': item.fobPriceError}">
                                        <b-form-input
                                            v-model.number="item.fob_price"
                                            size="sm"
                                            type="number"
                                            :disabled="isItemDisabled(item)"
                                            style="font-size: 11px;"
                                            :class="{'is-invalid': item.fobPriceError}"
                                            @blur="validateFobPrice(item)"
                                            @input="handleFobPriceChange(item)"
                                            @change="handleNumericInput($event, item, 'fob_price')"
                                        ></b-form-input>
                                        <b-form-invalid-feedback :state="!item.fobPriceError">
                                            {{ item.fobPriceError }}
                                        </b-form-invalid-feedback>
                                    </td>

                                        <td class="srrv">
                                            <b-form-input
                                            v-model.number="item.landed_cost_calculated"
                                            size="sm"
                                            readonly
                                            type="number"
                                            :disabled="isItemDisabled(item)"
                                            style="font-size: 11px;"
                                            @input="handleNumericInput($event, item, 'landed_cost_calculated')"
                                        ></b-form-input>
                                        </td>
                                        <td class="srrv">
                                        <div>
                                            {{item.quantity_ordered}} / {{ item.quantity_received }}
                                        </div>
                                        </td>

                                     <td class="srrv">
                                            <div v-if="read_only != true">
                                                <b-form-input
                                                    v-model.number="item.quantity_ordered"
                                                    size="sm"
                                                    type="number"
                                                    style="font-size: 11px;"
                                                    :disabled="isItemDisabled(item)"
                                                    @input="handleNumericInput($event, item, 'quantity_ordered')"
                                                    @change="handleOrderedQuantityChange(item)"
                                                    @blur="handleOrderedQuantityBlur(item)"
                                                ></b-form-input>
                                            </div>
                                            <div v-else>
                                                {{item.quantity_ordered}}
                                            </div>
                                        </td>

                                        <td class="srrv" :class="{'has-error': item.scheduledQuantityError}">
                                                    <b-form-input
                                                        v-model.number="item.quantity_scheduled"
                                                        size="sm"
                                                        type="number"
                                                        style="font-size: 11px;"

                                                        :min="getMinScheduledQuantity(item)"
                                                        :max="item.quantity_ordered"
                                                        :disabled="packet.userDetails.userrole != 'admin' || isItemDisabled(item) || isItemDisabled2(item)"
                                                        @blur="validateScheduledQuantity(item)"
                                                        @input="handleNumericInput($event, item, 'quantity_scheduled')"
                                                        :class="{'is-invalid': item.scheduledQuantityError}"
                                                    ></b-form-input>

                                                    <b-form-invalid-feedback :state="!item.scheduledQuantityError">
                                                        {{ item.scheduledQuantityError }}
                                                    </b-form-invalid-feedback>
                                                </td>

                                       <td class="srrv" :class="{'has-error': item.quantityError}">
                                            <b-form-input
                                                    v-model.number="item.quantity_received"
                                                    size="sm"
                                                    type="number"
                                                    style="font-size: 11px;"
                                                    :min="getMinQuantity(item)"
                                                    :max="item.quantity_ordered"
                                                    :disabled="isItemDisabled(item)"
                                                    @keydown="preventInvalidEntry($event, item)"
                                                    @blur="validateQuantity(item)"
                                                    @change="handleQuantityChange(item)"
                                                    @input="handleNumericInput($event, item, 'quantity_received')"
                                                    :class="{'is-invalid': item.quantityError}"
                                                ></b-form-input>
                                            <b-form-invalid-feedback :state="!item.quantityError">
                                                {{ item.quantityError }}
                                            </b-form-invalid-feedback>
                                        </td>

                                          <td class="srrv">
                                                <b-form-select
                                                    :options="coloredStatuses"
                                                    v-model="item.status"
                                                    size="sm"
                                                    style="font-size: 11px;"
                                                    :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                    @change="handleStatusChange(item)"
                                                    :state="getStatusState(item)"
                                                    :style="getSelectedStatusStyle(item.status)"
                                                ></b-form-select>
                                            </td>

                                     <td class="srrv">
                                        <div style="position: relative; display: inline-block;">
                                            <date-picker
                                                v-model="item.schedule_date"
                                                format="MM-DD-YYYY"
                                                :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                valueType="format"
                                                style="padding: 1px; font-size: 9px; text-align: center; border: 1px solid gray; width: 140px; font-size: 11px;"
                                                @change="handleScheduleDateChange(item)"
                                            ></date-picker>
                                            <b-badge
                                                v-if="item.scheduled_by_final_eta"
                                                variant="info"
                                                v-b-tooltip.hover
                                                title="Scheduled using Final ETA"
                                                style="position: absolute; top: 10px; right: -8px; z-index: 10; font-size: 9px; padding: 2px 4px;"
                                            >
                                                ETA
                                            </b-badge>
                                        </div>
                                    </td>
                                    <td class="srrv">
    <b-form-select
        :options="filteredLocations"
        v-model="item.locsub"
        size="sm"
        :disabled="isItemDisabled(item)"
        style="font-size: 11px;"
        @change="handleLocationChange(item)">
    </b-form-select>
</td>

                                        <td class="srrv">
                                            <date-picker
                                                v-model="item.receiving_date"
                                                format="MM-DD-YYYY"
                                                :disabled="isItemDisabled(item) || item.status === 5 || item.receiving_date_disabled || isWarehouseUser() || isItemDisabled2(item)"
                                                valueType="format"
                                                style="padding: 1px; font-size: 9px; text-align: center; border: 1px solid gray; width: 140px; font-size: 11px;"
                                            >
                                            </date-picker>
                                        </td>

                                        <td class="srrv">
                                            <b-form-input
                                                v-model="item.comments"
                                                size="sm"
                                                type="text"
                                                :disabled="isItemDisabled(item)"
                                                style="font-size: 11px;"
                                            ></b-form-input>
                                        </td>

                                        <td class="srrv" v-if="read_only != true">
                                          <div style="display: flex; align-items: center; justify-content: center; gap: 5px; flex-wrap: nowrap;">

                                              <!-- DELETE ITEM -->
                                              <b-button
                                                  size="sm"
                                                  variant="outline-danger"
                                                  :disabled="isItemDisabled(item)"
                                                  v-if="packet.userDetails.userrole == 'admin'"
                                                  @click="confirmRemoveItem(item)"
                                                  v-b-tooltip.hover
                                                  title="DELETE ITEM"
                                              >
                                                  <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                                              </b-button>

                                              <!-- Hidden file input -->
                                              <input
                                                  type="file"
                                                  accept="image/*"
                                                  @change="handleImageUpload($event, item, idx)"
                                                  style="display: none;"
                                                  :ref="'fileInput-' + idx"
                                                  :disabled="isItemDisabled(item)"
                                              >

                                              <!-- Upload button if no image -->
                                              <b-button
                                                  v-if="!item.images || item.images.length === 0"
                                                  size="sm"
                                                  variant="outline-primary"
                                                  @click="$refs['fileInput-' + idx][0].click()"
                                                  :disabled="isItemDisabled(item)"
                                                  v-b-tooltip.hover
                                                  title="UPLOAD IMAGES"
                                              >
                                                  <b-icon icon="cloud-upload-fill" aria-hidden="true"></b-icon>
                                              </b-button>

                                              <!-- Image preview if exists -->
                                              <div
                                                  v-else
                                                  style="position: relative; display: inline-block;"
                                              >
                                                  <img
                                                      :src="item.images[0].raw || item.images[0].url"
                                                      style="max-width: 40px; max-height: 40px; cursor: pointer;"
                                                      @click="showImagePreview(item)"
                                                      class="img-thumbnail"
                                                  >
                                                  <b-button
                                                      variant="danger"
                                                      size="xs"
                                                      @click="removeImage(item, idx)"
                                                      style="position: absolute; top: -8px; right: -8px; padding: 0px 4px;"
                                                  >
                                                      ×
                                                  </b-button>
                                              </div>

                                              <!-- Show all images button -->
                                              <b-button
                                                  size="sm"
                                                  variant="outline-primary"
                                                  v-if="item.pictures && item.pictures.length"
                                                  @click="showImages(item.pictures)"
                                                  v-b-tooltip.hover
                                                  title="SHOW IMAGES"
                                              >
                                                  <b-icon icon="image-fill" aria-hidden="true"></b-icon>
                                              </b-button>

                                          </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-card-text>
                    </div>
                    <b-card-text v-else>
                        <b-alert show variant="primary">NO ITEMS ADDED TO THIS ORDER YET.</b-alert>
                    </b-card-text>

                    <div>
                        <div v-if="items.length > 0">
                            <b-button size="sm" variant="success" @click="confirmSave">SAVE</b-button>
                            <b-button size="sm" variant="warning" @click="close_it" class="ml-2">CANCEL</b-button>
                        </div>
                        <div v-else>
                            <b-button size="sm" variant="warning" @click="close_it">CANCEL</b-button>
                        </div>
                    </div>
                </b-card-text>
            </span>
        </b-card>


        <!-- Confirmation Modal -->
        <b-modal id="confirmation-modal" :title="modalTitle" @ok="handleConfirmation">
            <p>{{ modalMessage }}</p>
        </b-modal>
        <b-card v-if="container_order_id" style="margin: 0px; margin-top: 10px; padding: 0px;" no-body>
    <b-alert show>CONTAINER ORDER HISTORY</b-alert>

    <div v-if="containerOrderHistory.length > 0" class="diver">
        <b-card-text>
            <table style="width: 100%;" class="text-monospace">
                <thead>
                    <tr>
                       <td class="srr"style="width:80px">DATE</td>
                        <td class="srr" style="width:100px">SKU</td>
                        <td class="srr" style="width:300px">DESCRIPTION</td>
                        <td class="srr" style="width:100px">QTY ORD</td>
                        <td class="srr" style="width:100px">QTY RCVD</td>
                        <td class="srr" style="width:120px">STATUS</td>
                        <td class="srr" style="width:120px">DROP LOCATION</td>
                        <td class="srr" style="width:100px">CHANGED BY</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="historyItem, idx in containerOrderHistory" :key="idx">
                        <td class="srrv">{{ historyItem.change_date }}</td>
                        <td class="srrv">{{ historyItem.product_sku }}</td>
                        <td class="srrv">{{ historyItem.item_description }}</td>
                        <td class="srrv">{{ historyItem.quantity_ordered }}</td>
                        <td class="srrv">{{ historyItem.quantity_received }}</td>
                        <td class="srrv">{{ historyItem.status_text }}</td>
                        <td class="srrv">{{ historyItem.drop_location_name || historyItem.drop_location }}</td>
                        <td class="srrv">{{ historyItem.changed_by }}</td>
                    </tr>
                </tbody>
            </table>
        </b-card-text>
    </div>

    <div v-else>
        <div v-if="historyLoading">
            <loading
                :active="true"
                :can-cancel="false"
                :is-full-page="false">
            </loading>
        </div>
        <div v-else>
            <b-card-text class="srrv">NO HISTORY FOR THIS CONTAINER ORDER YET</b-card-text>
        </div>
    </div>
</b-card>
    </div>
</template>

<script>
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Requestor from '@/utilities/Requestor';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css' // Optional CSS

export default {
    name: "CreateNewContainerOrder",
    props: ["viewdata"],
    components: { flatPickr, Loading, DatePicker, VueSimpleSuggest },
    data: function () {
        return {
            packet: {},
            _watchersSet: false,
            colors: [

                { value: "gray", text: "GRAY" },
                { value: "brown", text: "BROWN" },
                { value: "white", text: "WHITE" },
                { value: "black", text: "BLACK" },
                { value: "blue", text: "BLUE" },
                { value: "green", text: "GREEN" },
                { value: "violet", text: "VIOLET" },
                { value: "red", text: "RED" },
                { value: "lightblue", text: "LIGHTBLUE" },
                { value: "lightgreen", text: "LIGHTGREEN" },
                { value: "violet", text: "VIOLET" },
                { value: "yellow", text: "YELLOW" },
            ],
            statuses: [
                {value: 1, text: "NEW"},
                {value: 2, text: "ORDERED"},
                {value: 3, text: "SCHEDULED"},
                {value: 4, text: "PARTIAL"},
                {value: 5, text: "RECEIVED"},
                {value: 6, text: "COMPLETED"},
                {value: 7, text: "ARCHIVED"},
            ],
              modalTitle: '',
            modalMessage: '',
            confirmationAction: null,
            confirmationData: null,
            container_order_id: null,
            container_order_vendor_id: null,
            vendor_id: null,
            ship_to: null,
            bill_to: null,
            requested_eta: null,
            po_number: null,
            po_date: null,
            items: [],
            products: [],
            vendor_products: [],
            product_search_keyword: '',
            loading: null,
            status: 1,
            mainScheduleDate: null,
            mainReceivingLocation: null,
            autoApplyMainDate: true,
            autoApplyMainReceivingLocation: true,
            final_eta: null,
            landed_cost_calculated:null,
             receiving_location_id: null,
            containerOrderHistory: [],
            historyLoading: false,


            /*mp_invoice_date: null,
            mp_invoice_number: null,
            mp_payment_due_date: null,
            mp_total_amount: null,
            mp_payment_1: null,
            mp_payment_1_date: null,
            mp_payment_2: null,
            mp_payment_2_date: null,
            mp_balance: null,
            mp_payment_method: null,

            cc_container_number: null,
            cc_bl_number: null,
            cc_freight_invoice_number: null,
            cc_freight_invoice_date: null,
            cc_freight_company: null,
            cc_amount: null,
            cc_payment_date: null,
            cc_payment_method: null,

            terrif_total: null,
            terrif_paid_date: null,
            terrif_demurrage_charges: null,
            terrif_demurrage_payment_date: null,
            terrif_broker_fees: null,
            terrif_handling_charges: null,
            terrif_detention_charges: null,

            truck_invoice_date: null,
            truck_company: null,
            trucking_invoice_number: null,
            trucking_invoice_amount: null,
            trucking_payment_date: null,
            trucking_payment_method: null,

            receiving_location: null,

            //nitems_received: null,
            comments: null,
            pictures: null,
            completed: false*/

        }
    },
    methods: {
calculateLandedCost(item) {
    if (!item.fob_price || item.fob_price <= 0) {
        item.landed_cost_calculated = 0;
        return;
    }

    const fobPrice = parseFloat(item.fob_price);

    // Get cost data from container order
    if (this.items.length > 0) {
        // Find a sample item that has calculated landed cost
        const sampleItem = this.items.find(item => item.landed_cost_calculated && item.fob_price);
        if (sampleItem && sampleItem.fob_price > 0) {
            // Use the same ratio as backend calculation
            const ratio = sampleItem.landed_cost_calculated / sampleItem.fob_price;
            item.landed_cost_calculated = fobPrice * ratio;
        } else {
            // Fallback: calculate based on available cost data
            this.calculateLandedCostFromContainerData(item);
        }
    } else {
        this.calculateLandedCostFromContainerData(item);
    }

    // Round to 2 decimal places
    item.landed_cost_calculated = Math.round(item.landed_cost_calculated * 100) / 100;
},
calculateLandedCostFromContainerData(item) {
    const fobPrice = parseFloat(item.fob_price);

    // Get container order cost data
    const tariff = parseFloat(this.tariff) || 0;
    const transport = parseFloat(this.transport) || 0;
    const otherCost = parseFloat(this.other_cost) || 0;
    const invoiceTotal = parseFloat(this.invoice_total) || 0;

    if (invoiceTotal > 0) {
        const totalAdditionalCosts = tariff + transport + otherCost;
        const costRatio = totalAdditionalCosts / invoiceTotal;
        const additionalCostPerUnit = fobPrice * costRatio;
        item.landed_cost_calculated = fobPrice + additionalCostPerUnit;
    } else {
        // Default calculation if no invoice total
        item.landed_cost_calculated = fobPrice * 1.2; // 20% markup
    }
},

getDefaultReceivingLocation() {
    console.log("Getting default receiving location...");

    // Priority 1: Use the first available sub-location from filteredLocations
    if (this.filteredLocations && this.filteredLocations.length > 0) {
        const defaultLocation = this.filteredLocations[0].value;
        console.log("Using first filtered location:", defaultLocation);
        return defaultLocation;
    }

    // Priority 2: Use mainReceivingLocation if it's a valid sub-location
    if (this.mainReceivingLocation) {
        const isValidSubLocation = this.filteredLocations.some(loc =>
            loc.value === this.mainReceivingLocation
        );
        if (isValidSubLocation) {
            console.log("Using main receiving location:", this.mainReceivingLocation);
            return this.mainReceivingLocation;
        }
    }

    // Priority 3: If no filtered locations, try to find any location that starts with 40|
    if (this.packet.locsubs && this.packet.locsubs.length > 0) {
        const receivingLoc = this.receiving_location_id.toString();
        const firstMatchingLocation = this.packet.locsubs.find(loc =>
            loc.value.toString().startsWith(receivingLoc + '|')
        );
        if (firstMatchingLocation) {
            console.log("Found matching location:", firstMatchingLocation.value);
            return firstMatchingLocation.value;
        }
    }

    console.log("No default location found, returning null");
    return null;
},
        handleLocationChange(item) {
    // Clear any location-related errors when location is set
    if (item.locsub && item.locsub !== '' && item.quantityError && item.quantityError.includes("Receiving location")) {
        this.$set(item, 'quantityError', null);
    }

    // If item has full quantity received but wasn't marked as RECEIVED due to missing location,
    // now that location is set, automatically mark as RECEIVED
    const received = Number(item.quantity_received) || 0;
    const ordered = Number(item.quantity_ordered) || 0;

    if (received === ordered && item.locsub && item.locsub !== '' && item.status !== 5) {
        this.$nextTick(() => {
            this.autoUpdateStatusBasedOnQuantity(item);
        });
    }
},
        handleOrderedQuantityChange(item) {
    // Force status update when ordered quantity changes
    this.$nextTick(() => {
        this.autoUpdateStatusBasedOnOrderedQuantity(item);
    });
},
handleFobPriceChange(item) {
    this.handleNumericInput(item.fob_price, item, 'fob_price');

    // Recalculate landed cost when FOB price changes
    this.$nextTick(() => {
        this.calculateLandedCost(item);
    });
},
      handleQuantityChange(item) {
    // Force status update when quantity changes
    this.$nextTick(() => {
        this.autoUpdateStatusBasedOnQuantity(item);
    });
},
autoUpdateStatusBasedOnOrderedQuantity(item) {
    if (!item || item.manuallyChangingStatus) return;

    const ordered = Number(item.quantity_ordered) || 0;
    const received = Number(item.quantity_received) || 0;
    const scheduled = Number(item.quantity_scheduled) || 0;

    console.log(`Auto-updating status based on ordered quantity for ${item.product_sku}: ordered=${ordered}, received=${received}, scheduled=${scheduled}, current status=${item.status}`);

    // Don't auto-update if user manually set the status recently
    if (item.manuallyChangedStatus) return;

    // If ordered quantity is greater than 0, set status to ORDERED (unless already in a higher status)
    if (ordered > 0) {
        // Only set to ORDERED if current status is lower than ORDERED (NEW status is 1, ORDERED is 2)
        if (item.status < 2) {
            item.status = 2; // ORDERED
            console.log("Set status to ORDERED (ordered quantity > 0)");

            // Apply default settings when status becomes ORDERED
            this.applyDefaultSettings(item);
        }

        // If scheduled quantity exists and status is lower than SCHEDULED, consider moving to SCHEDULED status
        if (scheduled > 0 && item.status < 3) {
            item.status = 3; // SCHEDULED
            console.log("Set status to SCHEDULED (scheduled quantity exists)");
        }

        // If quantity is already received, maintain RECEIVED status (highest priority)
        if (received > 0 && received === ordered && item.status < 5) {
            // But only if receiving location is set
            if (item.locsub && item.locsub !== '') {
                item.status = 5; // RECEIVED
                console.log("Set status to RECEIVED (quantity already received)");
            } else if (received > 0 && received < ordered && item.status < 4) {
                item.status = 4; // PARTIAL
                console.log("Set status to PARTIAL (partial quantity received)");
            }
        }
    }
    else if (ordered <= 0) {
        // If ordered quantity is 0 or negative, set status back to NEW only if no other activity
        if (item.status > 1 && received === 0 && scheduled === 0) {
            item.status = 1; // NEW
            console.log("Set status to NEW (ordered quantity <= 0 and no activity)");
        }
    }
},
autoUpdateStatusBasedOnQuantity(item) {
    if (!item || item.manuallyChangingStatus) return;

    const received = Number(item.quantity_received) || 0;
    const ordered = Number(item.quantity_ordered) || 0;

    console.log(`Auto-updating status for ${item.product_sku}: received=${received}, ordered=${ordered}`);

    // Don't auto-update if user manually set the status recently
    if (item.manuallyChangedStatus) return;

    // If no ordered quantity, don't process received quantity logic
    if (ordered <= 0) return;

    // Auto-update status based on quantity comparison
    if (received === 0) {
        // If no quantity received, revert to appropriate status based on ordered quantity
        if (item.quantity_scheduled > 0) {
            if (item.status !== 3) {
                item.status = 3; // SCHEDULED
                console.log("Set status to SCHEDULED (no quantity received but scheduled)");
            }
        } else if (item.status !== 2 && ordered > 0) {
            item.status = 2; // ORDERED
            console.log("Set status to ORDERED (no quantity received but ordered)");
        }
    }
    else if (received === ordered) {
        // When receiving quantity equals ordered quantity, check if receiving location is set
        if (!item.locsub || item.locsub === '') {
            // Cannot mark as RECEIVED without receiving location
            if (item.status === 5) {
                // Revert status if trying to set to RECEIVED without location
                item.status = 4; // Fall back to PARTIAL
                console.log("Cannot set to RECEIVED: Receiving location is required");

                // Show error message
                this.$set(item, 'quantityError', "Receiving location is required to mark as RECEIVED");

                this.$bvToast.toast(
                    `Receiving location is required for ${item.product_sku} to mark as RECEIVED`,
                    { title: "Validation Error", autoHideDelay: 3000, variant: "warning" }
                );
            }
            return; // Don't proceed with RECEIVED status without location
        }

        // If receiving location is set, proceed with RECEIVED status
        if (item.status !== 5) {
            item.status = 5; // RECEIVED
            console.log("Set status to RECEIVED (full quantity received)");

            // Clear any previous errors
            this.$set(item, 'quantityError', null);

            // Also set the receiving date to current date if not set
            if (!item.receiving_date) {
                item.receiving_date = moment().format('MM-DD-YYYY');
            }

            // Disable receiving date for received items
            item.receiving_date_disabled = true;
        }
    }
    else if (received > 0 && received < ordered) {
        // When receiving quantity is less than ordered quantity, set status to PARTIAL
        if (item.status !== 4) {
            item.status = 4; // PARTIAL
            console.log("Set status to PARTIAL (partial quantity received)");

            // Enable receiving date for partial items
            item.receiving_date_disabled = false;
        }
    }

    // Validate the new status
    this.validateStatusConsistency(item);
},
   validateStatusConsistency(item) {
    const received = Number(item.quantity_received) || 0;
    const ordered = Number(item.quantity_ordered) || 0;
    const status = Number(item.status) || 1;

    // Clear any existing errors
    this.$set(item, 'quantityError', null);

    // Validate RECEIVED status requirements
    if (status === 5) {
        if (received !== ordered) {
            this.$set(item, 'quantityError', "Status cannot be 'RECEIVED' unless full quantity is received");
            return false;
        }

        if (!item.locsub || item.locsub === '') {
            this.$set(item, 'quantityError', "Receiving location is required for 'RECEIVED' status");
            return false;
        }
    }

    // Validate PARTIAL status requirements
    if (status === 4 && (received === 0 || received >= ordered)) {
        this.$set(item, 'quantityError', "Status cannot be 'PARTIAL' unless partial quantity is received");
        return false;
    }

    return true;
},
        fetchContainerOrderHistory: function() {
    let data = {id: this.container_order_id}
    let path = "/api/vendor/get_container_order_history/"
    let that = this;
    let s = function(response) {
        if (response.data.error){
            that.$bvToast.toast(
                "ERROR RETRIEVING CONTAINER ORDER HISTORY",
                {title: "Error", autoHideDelay: 1500, variant:"warning"}
            );
        }
        else {
            that.containerOrderHistory = response.data.result;
        }
        that.historyLoading = false;
    }

    let f = function(error) {
        that.$bvToast.toast(
            "ERROR OCCURRED WITH HISTORY. PLEASE TRY LATER.",
            {title: "Error", autoHideDelay: 1500, variant:"danger"}
        );
        that.historyLoading = false;
    }
    this.historyLoading = true;
    Requestor.getSyncP(path, data, this, s, f);
},

// Modify your save method to refresh history after save
executeSave: function() {
    const changedItems = this.getChangedItems();

    let data = {
        container_order_id: this.container_order_id,
        items: changedItems,
        created_by: this.packet.userDetails.username,
        location_id: this.packet.userDetails.properties.location_id
    };

    console.log("Sending to server:", JSON.stringify(data, null, 2));

    let that = this;
    let path = "/api/vendor/save_container_order_items/";

    let s = function (response) {
        if (response.data.error) {
            that.$bvToast.toast(
                response.data.error,
                { title: "Error", autoHideDelay: 1500, variant: "warning" }
            );
        } else {
            that.$bvToast.toast(
                "Changes saved successfully",
                { title: "Success", autoHideDelay: 1500, variant: "success" }
            );

            // Update original values after successful save
            that.items.forEach(item => {
                if (that.hasItemChanges(item)) {
                    that.$set(item, 'original_quantity_received', item.quantity_received);
                    that.$set(item, 'original_status', item.status);
                    that.$set(item, 'original_quantity_scheduled', item.quantity_scheduled);
                    that.$set(item, 'original_fob_price', item.fob_price);
                    that.$set(item, 'original_landed_cost', item.landed_cost);
                    that.$set(item, 'original_locsub', item.locsub);
                    that.$set(item, 'original_schedule_date', item.schedule_date);
                    that.$set(item, 'original_receiving_date', item.receiving_date);
                    that.$set(item, 'original_comments', item.comments);
                    that.$set(item, 'original_color', item.color);
                }
            });

            // Refresh history after successful save
            that.fetchContainerOrderHistory();
        }
        that.loading = false;
    };

    let f = function (error) {
        console.log("Save error:", error);
        that.$bvToast.toast(
            "Error occurred. Please try again.",
            { title: "Error", autoHideDelay: 1500, variant: "danger" }
        );
        that.loading = false;
    };

    this.loading = true;
    Requestor.postSyncP(path, data, this, s, f);
},
         validateFobPriceForScheduled(item) {
        if (item.status === 3) { // SCHEDULED status
            if (!item.fob_price || item.fob_price <= 0 || isNaN(item.fob_price)) {
                this.$set(item, 'fobPriceError', 'Valid FOB price is required when status is SCHEDULED');
                return false;
            }
        }
        this.$set(item, 'fobPriceError', null);
        return true;
    },


    isWarehouseUser() {
    return this.packet.userDetails && this.packet.userDetails.userrole === 'warehouseuser';
  },
    statusClass() {
    return (status) => {
      return {
        'status-new': status === 1,
        'status-ordered': status === 2,
        'status-scheduled': status === 3,
        'status-in-transit': status === 4,
        'status-partial': status === 5,
        'status-received': status === 6,
        'status-completed': status === 7,
        'status-archived': status === 8
      };
    };
  },
          getSelectedStatusStyle(statusValue) {
    const status = this.coloredStatuses.find(s => s.value === statusValue);
    return status ? status.style : {};
  },
        statusColors() {
            return {

                1: '#f8f9fa', // NEW - light gray
                2: '#e3f2fd', // ORDERED - very light blue
                3: '#fff3e0', // SCHEDULED - light blue
                4: '#fff9c4', // PARTIAL - light yellow
                5: '#c8e6c9', // RECEIVED - light green
                6: '#c8e6c9', // completed - light green
                7: '#f5f5f5'  // ARCHIVED - light gray
            };
        },

      getTextColor(backgroundColor) {
    if (!backgroundColor || typeof backgroundColor !== "string") {
        // Fallback: default to black text
        return "#000000";
    }

    // Normalize input
    const hex = backgroundColor.replace("#", "").trim();

    // Handle shorthand colors (#fff → #ffffff)
    const normalizedHex = hex.length === 3
        ? hex.split("").map(c => c + c).join("")
        : hex;

    const r = parseInt(normalizedHex.substr(0, 2), 16);
    const g = parseInt(normalizedHex.substr(2, 2), 16);
    const b = parseInt(normalizedHex.substr(4, 2), 16);

    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    return luminance > 0.5 ? "#000000" : "#ffffff";
},

   formatNumber(value) {
    if (value === null || value === undefined || value === '') return '0';
    // Convert to number first, then to string
    const numValue = Number(value);
    return isNaN(numValue) ? '0' : numValue.toString();
},
 handleNumericInput(value, item, field) {
    // Convert empty string to null or 0
    if (value === '' || value === null) {
        this.$set(item, field, 0);
    } else {
        this.$set(item, field, Number(value));
    }

    // Trigger status update specifically for ordered quantity changes
    if (field === 'quantity_ordered') {
        this.$nextTick(() => {
            // Force status update immediately
            this.autoUpdateStatusBasedOnOrderedQuantity(item);

            // Also trigger a general quantity update to handle received/scheduled logic
            this.autoUpdateStatusBasedOnQuantity(item);
        });
    }
},
handleOrderedQuantityBlur(item) {
    // Force status update when ordered quantity input loses focus
    this.$nextTick(() => {
        this.autoUpdateStatusBasedOnOrderedQuantity(item);
    });
},

    // Or use a computed setter approach
    sanitizeNumericValue(value) {
        return value === '' || value === null ? 0 : Number(value);
    },
        handleScheduleDateChange(item) {
    // Check if the user manually selected a date different from final_eta
    if (item.schedule_date && this.final_eta && item.schedule_date !== this.final_eta) {
        // Remove the scheduled_by_final_eta flag to hide the badge
        item.scheduled_by_final_eta = false;
    } else if (item.schedule_date === this.final_eta) {
        // If they selected the same date as final_eta, keep the badge
        item.scheduled_by_final_eta = true;
    }
},
        applyDefaultsToAllItems() {
        this.items.forEach(item => {
            if ([1, 2].includes(item.status) && item.status !== 3) {
                this.applyDefaultSettings(item);
            }
        });

        this.$bvToast.toast(
            "Defaults applied to all NEW/ORDERED items",
            { title: "Defaults Applied", autoHideDelay: 3000, variant: "success" }
        );
    },
        applyDefaultSettings(item) {
    // Only apply defaults for NEW or ORDERED status items that aren't already SCHEDULED
    if ([1, 2].includes(item.status) && item.status !== 3) {
        // Apply default schedule date from final_eta if available
        if (this.final_eta && !item.schedule_date) {
            item.schedule_date = this.final_eta;
            item.scheduled_by_final_eta = true; // Flag to show badge
            console.log("Applied final_eta date to item:", item.product_sku, this.final_eta);
        } else if (!this.final_eta) {
            console.log("final_eta is not available");
        }

        // Apply default receiving location if available
        if (this.mainReceivingLocation && !item.locsub) {
            item.locsub = this.mainReceivingLocation;
            console.log("Applied receiving location to item:", item.product_sku, this.mainReceivingLocation);
        } else if (!this.mainReceivingLocation) {
            console.log("mainReceivingLocation is not available");
        }
    }
},
        confirmSave() {
    this.modalTitle = 'Confirm Save';
    this.modalMessage = 'Are you sure you want to save all changes?';
    this.confirmationAction = 'save';
    this.$bvModal.show('confirmation-modal');
},

confirmRemoveItem(item) {
    if (!item.container_order_item_id) {
        this.$bvToast.toast(
            "Cannot delete: Item ID is missing",
            { title: "Error", autoHideDelay: 3000, variant: "danger" }
        );
        return;
    }
    
    this.modalTitle = 'Confirm Removal';
    this.modalMessage = `Are you sure you want to remove ${item.product_sku} from this order?`;
    this.confirmationAction = 'remove';
    this.confirmationData = item;
    this.$bvModal.show('confirmation-modal');
},

showImagePreview(item) {
    if (!item.images || item.images.length === 0) return;

    this.$bvModal.msgBoxOk('', {
        title: 'Image Preview',
        centered: true,
        size: 'lg',
        headerBgVariant: 'dark',
        headerTextVariant: 'light',
        bodyClass: 'text-center',
        content: () => (
            <div>
                <img src={item.images[0].raw} style="max-width: 100%; max-height: 70vh;" />
            </div>
        )
    });
},

showImages(pictures) {
    pictures.forEach(pic => {
        if (pic.url) {
            window.open(pic.url, '_blank');
        }
    });
},
          applyMainScheduleDate() {
            if (!this.mainScheduleDate) return;

            this.items.forEach(item => {
                // Only update items that aren't disabled and don't have received status
                if (!this.isItemDisabled(item) && item.status !== 5) {
                    item.schedule_date = this.mainScheduleDate;
                    item.scheduled_by_final_eta = false;
                    // If setting a schedule date, also set status to scheduled if not already
                    if (item.status !== 3) {
                        item.status = 3;
                    }
                    // Set scheduled quantity to ordered quantity if not already set
                    if (!item.quantity_scheduled || item.quantity_scheduled === 0) {
                        item.quantity_scheduled = item.quantity_ordered;
                    }
                }
            });

            this.$bvToast.toast(
                `Main schedule date applied to all items`,
                { title: "Success", autoHideDelay: 3000, variant: "success" }
            );
        },

        applyMainReceivingLocation() {
            if (!this.mainReceivingLocation) return;

            this.items.forEach(item => {
                // Only update items that aren't disabled
                if (!this.isItemDisabled(item)) {
                    item.locsub = this.mainReceivingLocation;
                }
            });

            this.$bvToast.toast(
                `Main receiving location applied to all items`,
                { title: "Success", autoHideDelay: 3000, variant: "success" }
            );
        },


        applyBothMainSettings() {
            if (!this.mainScheduleDate || !this.mainReceivingLocation) return;

            this.items.forEach(item => {
                // Only update items that aren't disabled and don't have received status
                if (!this.isItemDisabled(item) && item.status !== 5) {
                    // Apply schedule date
                    item.schedule_date = this.mainScheduleDate;
                    if (item.status !== 3) {
                        item.status = 3;
                    }
                    if (!item.quantity_scheduled || item.quantity_scheduled === 0) {
                        item.quantity_scheduled = item.quantity_ordered;
                    }

                    // Apply receiving location
                    item.locsub = this.mainReceivingLocation;
                }
            });

            this.$bvToast.toast(
                `Main schedule date and receiving location applied to all items`,
                { title: "Success", autoHideDelay: 3000, variant: "success" }
            );
        },

        showImages(pictures) {
            pictures.forEach(pic => {
                if (pic.url) {
                    window.open(pic.url, '_blank');
                }
            });
        },

        handleImageUpload(event, item, idx) {
            const input = event.target;
            if (input.files && input.files[0]) {
                const img = { raw: "", url: "", file: null };
                const reader = new FileReader();

                reader.onload = (e) => {
                    img.raw = e.target.result;
                    if (!item.images) this.$set(item, 'images', []);
                    item.images = [img]; // Replace any existing image
                    this.$set(this.items, idx, item);
                };

                img.file = input.files[0];
                reader.readAsDataURL(input.files[0]);
            }
        },

        removeImage(item, idx) {
            item.images = [];
            this.$refs['fileInput-' + idx][0].value = '';
            this.$set(this.items, idx, item);
        },

        showImagePreview(item) {
            if (!item.images || item.images.length === 0) return;

            this.$bvModal.msgBoxOk('', {
                title: 'Image Preview',
                centered: true,
                size: 'lg',
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyClass: 'text-center',
                content: () => (
                    <div>
                        <img src={item.images[0].raw} style="max-width: 100%; max-height: 70vh;" />
                    </div>
                )
            });
        },

        // validate: function(data){
        //     let errors = []
        //     // if (!data.po_number){
        //     //     errors.push({message: "PLEASE SPECIFY A VALID PO#"})
        //     // }
        //     // if(!data.ship_to || !data.bill_to){
        //     //     errors.push({message: "PLEASE SPECIFY A VALID SHIP-TO / BILL-TO LOCATIONS"})
        //     // }
        //     // if(!data.items.length < 0){
        //     //     errors.push({message: "PLEASE ADD AT LEAST ONE PRODUCT IN THIS ORDER."})
        //     // }

        //     for (var i=0; i<data.items.length; i++){
        //         if (!data.items[i].product_sku){
        //             errors.push({message: "ONE OR MORE PRODUCTS ARE MISSING THEIR SKUS."});
        //         }
        //         if (!data.items[i].quantity_ordered || data.items[i].quantity_ordered <= 0){
        //             errors.push({message: "PLEASE SPECIFY A VALID QUANTITY FOR EACH ITEM ORDERED."});
        //         }


        //     }

        //     return errors;
        // },

        // validate: function(data) {
        //     let errors = [];

        //     for (let i = 0; i < data.items.length; i++) {
        //         const item = data.items[i];
        //         const quantityReceived = item.quantity_received;
        //         const quantityOrdered = item.quantity_ordered;
        //         const status = item.status;
        //         const originalQuantityReceived = item.original_quantity_received || 0;

        //         // 1. Validate quantity_received exists and is valid
        //         if (quantityReceived === undefined || quantityReceived === null) {
        //             errors.push({ message: "PLEASE SPECIFY A QUANTITY RECEIVED FOR EACH ITEM." });
        //         } else if (isNaN(quantityReceived)) {
        //             errors.push({ message: "QUANTITY RECEIVED MUST BE A VALID NUMBER." });
        //         } else if (quantityReceived < 0) {
        //             errors.push({ message: "QUANTITY RECEIVED CANNOT BE NEGATIVE." });
        //         }

        //         // New validation: If quantity received > 0, status must be Partial or Received
        //         if (quantityReceived > 0 && ![3, 4].includes(status)) {
        //             errors.push({
        //                 message: `STATUS MUST BE "PARTIAL" OR "RECEIVED" WHEN QUANTITY IS RECEIVED FOR ITEM ${i + 1}.`
        //             });
        //         }

        //         // 2. Validate quantity_received ≤ quantity_ordered (if ordered quantity exists)
        //         if (quantityOrdered !== undefined && quantityOrdered !== null && quantityReceived > quantityOrdered) {
        //             errors.push({
        //                 message: `QUANTITY RECEIVED (${quantityReceived}) CANNOT EXCEED ORDERED QUANTITY (${quantityOrdered}) FOR ITEM ${i + 1}.`
        //             });
        //         }

        //         // New validation: For first-time entries (originalQuantityReceived === 0)
        //         if (originalQuantityReceived === 0) {
        //             // If receiving partial quantity (1 to quantity_ordered-1)
        //             if (quantityReceived > 0 && quantityReceived < quantityOrdered) {
        //                 if (status !== 4) { // Must be PARTIAL status
        //                     errors.push({
        //                         message: `STATUS MUST BE "PARTIAL" WHEN RECEIVING PARTIAL QUANTITY (${quantityReceived} OF ${quantityOrdered}) FOR ITEM ${i + 1}.`
        //                     });
        //                 }
        //             }
        //             // If receiving full quantity
        //             else if (quantityReceived === quantityOrdered) {
        //                 if (status !== 3) { // Must be RECEIVED status
        //                     errors.push({
        //                         message: `STATUS MUST BE "RECEIVED" WHEN FULL QUANTITY IS RECEIVED FOR ITEM ${i + 1}.`
        //                     });
        //                 }
        //             }
        //         }

        //         // 3. Validate status-specific rules
        //         if (status === 3) { // RECEIVED
        //             if (quantityReceived === 0) {
        //                 errors.push({
        //                     message: `QUANTITY RECEIVED CANNOT BE ZERO WHEN STATUS IS "RECEIVED" FOR ITEM ${i + 1}.`
        //                 });
        //             } else if (quantityReceived < quantityOrdered) {
        //                 errors.push({
        //                     message: `STATUS CANNOT BE "RECEIVED" IF QUANTITY RECEIVED (${quantityReceived}) < ORDERED QUANTITY (${quantityOrdered}). USE "PARTIAL" INSTEAD.`
        //                 });
        //             }
        //         } else if (status === 4) { // PARTIAL
        //             if (quantityReceived === 0) {
        //                 errors.push({
        //                     message: `QUANTITY RECEIVED CANNOT BE ZERO WHEN STATUS IS "PARTIAL" FOR ITEM ${i + 1}.`
        //                 });
        //             } else if (quantityReceived >= quantityOrdered) {
        //                 errors.push({
        //                     message: `STATUS CANNOT BE "PARTIAL" IF QUANTITY RECEIVED (${quantityReceived}) ≥ ORDERED QUANTITY (${quantityOrdered}). USE "RECEIVED" INSTEAD.`
        //                 });
        //             }
        //         }
        //     }

        //     return errors;
        // },

//       validate: function(data) {
//     let errors = [];

//     // ====== General validations ======
//     if (!data.container_order_id) {
//         errors.push({ message: "CONTAINER ORDER ID IS MISSING." });
//     }

//     if (!data.items || data.items.length <= 0) {
//         errors.push({ message: "PLEASE ADD AT LEAST ONE PRODUCT IN THIS ORDER." });
//         return errors; // No need to continue if no items
//     }

//     // ====== Per-item validations ======
//     for (let i = 0; i < data.items.length; i++) {
//         const item = data.items[i];
//         const quantityReceived = Number(item.quantity_received) || 0;
//         const quantityOrdered = Number(item.quantity_ordered) || 0;
//         const quantityScheduled = Number(item.quantity_scheduled) || 0;
//         const status = Number(item.status) || 1;
//         const originalQuantityReceived = Number(item.original_quantity_received) || 0;

//         // --- Validate SKU and ordered quantity ---
//         if (!item.product_sku) {
//             errors.push({ message: `ITEM ${i + 1}: PRODUCT SKU IS MISSING.` });
//         }

//         if (!quantityOrdered || quantityOrdered <= 0) {
//             errors.push({ message: `ITEM ${i + 1}: PLEASE SPECIFY A VALID ORDERED QUANTITY.` });
//         }

//         // Skip rest if no quantityOrdered defined
//         if (quantityOrdered === undefined || quantityOrdered === null || isNaN(quantityOrdered)) continue;

//         // --- Validate quantity_received ---
//         if (([4, 5].includes(status) && (quantityReceived === undefined || quantityReceived === null))) {
//             errors.push({ message: `ITEM ${i + 1}: PLEASE SPECIFY A QUANTITY RECEIVED.` });
//         } else if (isNaN(quantityReceived)) {
//             errors.push({ message: `ITEM ${i + 1}: QUANTITY RECEIVED MUST BE A VALID NUMBER.` });
//         } else if (quantityReceived < 0) {
//             errors.push({ message: `ITEM ${i + 1}: QUANTITY RECEIVED CANNOT BE NEGATIVE.` });
//         }

//         // --- Validate quantity_scheduled ---
//         if (isNaN(quantityScheduled)) {
//             errors.push({ message: `ITEM ${i + 1}: SCHEDULED QUANTITY MUST BE A VALID NUMBER.` });
//         } else if (quantityScheduled < 0) {
//             errors.push({ message: `ITEM ${i + 1}: SCHEDULED QUANTITY CANNOT BE NEGATIVE.` });
//         } else if (quantityScheduled > quantityOrdered) {
//             errors.push({ message: `ITEM ${i + 1}: SCHEDULED QUANTITY CANNOT EXCEED ORDERED QUANTITY.` });
//         }

//         // --- Validate scheduled date for scheduled items ---
//         if (quantityScheduled > 0 && !item.scheduled_date) {
//             errors.push({ message: `ITEM ${i + 1}: SCHEDULED DATE IS REQUIRED WHEN QUANTITY IS SCHEDULED.` });
//         }

//         // --- Validate receiving date for received/partial items ---
//         if ([4, 5].includes(status) && !item.receiving_date) {
//             errors.push({ message: `ITEM ${i + 1}: RECEIVING DATE IS REQUIRED FOR PARTIAL OR RECEIVED STATUS.` });
//         }

//         // --- Validate receiving location ---
//         if (!item.locsub) {
//             errors.push({ message: `ITEM ${i + 1}: RECEIVING LOCATION IS REQUIRED.` });
//         }

//         // --- Validate received > 0 requires Partial or Received status ---
//         if (quantityReceived > 0 && ![4, 5].includes(status)) {
//             errors.push({
//                 message: `ITEM ${i + 1}: STATUS MUST BE "PARTIAL" OR "RECEIVED" WHEN QUANTITY IS RECEIVED.`
//             });
//         }

//         // --- Quantity received cannot exceed ordered ---
//         if (quantityReceived > quantityOrdered) {
//             errors.push({
//                 message: `ITEM ${i + 1}: QUANTITY RECEIVED (${quantityReceived}) CANNOT EXCEED ORDERED (${quantityOrdered}).`
//             });
//         }

//         // --- First-time receiving validations ---
//         if (originalQuantityReceived === 0) {
//             if (quantityReceived > 0 && quantityReceived < quantityOrdered && status !== 4) {
//                 errors.push({
//                     message: `ITEM ${i + 1}: STATUS MUST BE "PARTIAL" WHEN RECEIVING PARTIAL QUANTITY (${quantityReceived} OF ${quantityOrdered}).`
//                 });
//             } else if (quantityReceived === quantityOrdered && status !== 5) {
//                 errors.push({
//                     message: `ITEM ${i + 1}: STATUS MUST BE "RECEIVED" WHEN FULL QUANTITY IS RECEIVED.`
//                 });
//             }
//         }

//         // --- Status-specific validations ---
//         if (status === 5) { // RECEIVED
//             if (quantityReceived === 0) {
//                 errors.push({
//                     message: `ITEM ${i + 1}: QUANTITY RECEIVED CANNOT BE ZERO WHEN STATUS IS "RECEIVED".`
//                 });
//             } else if (quantityReceived < quantityOrdered) {
//                 errors.push({
//                     message: `ITEM ${i + 1}: STATUS CANNOT BE "RECEIVED" IF QUANTITY RECEIVED (${quantityReceived}) < ORDERED (${quantityOrdered}). USE "PARTIAL" INSTEAD.`
//                 });
//             }
//         } else if (status === 4) { // PARTIAL
//             if (quantityReceived === 0) {
//                 errors.push({
//                     message: `ITEM ${i + 1}: QUANTITY RECEIVED CANNOT BE ZERO WHEN STATUS IS "PARTIAL".`
//                 });
//             } else if (quantityReceived >= quantityOrdered) {
//                 errors.push({
//                     message: `ITEM ${i + 1}: STATUS CANNOT BE "PARTIAL" IF QUANTITY RECEIVED (${quantityReceived}) ≥ ORDERED (${quantityOrdered}). USE "RECEIVED" INSTEAD.`
//                 });
//             }
//         } else if (status === 3) { // SCHEDULED
//             if (quantityScheduled === 0) {
//                 errors.push({
//                     message: `ITEM ${i + 1}: SCHEDULED QUANTITY CANNOT BE ZERO WHEN STATUS IS "SCHEDULED".`
//                 });
//             }
//         }
//     }

//     return errors;
// },
validate: function(data) {
    let errors = [];

    if (!data.container_order_id) {
        errors.push({ message: "CONTAINER ORDER ID IS MISSING." });
    }

    if (!data.items || data.items.length <= 0) {
        errors.push({ message: "PLEASE ADD AT LEAST ONE PRODUCT." });
        return errors;
    }

    // Only validate items that have changes
    for (let i = 0; i < data.items.length; i++) {
        const item = data.items[i];

        // Skip validation for unchanged items
        if (!this.hasItemChanges(item)) continue;

        const received = Number(item.quantity_received) || 0;
        const ordered = Number(item.quantity_ordered) || 0;
        const scheduled = Number(item.quantity_scheduled) || 0;
        const status = Number(item.status) || 1;

        // CRITICAL VALIDATIONS ONLY
        if (received > ordered) {
            errors.push({ message: `ITEM ${i + 1}: Received quantity (${received}) cannot exceed ordered quantity (${ordered})` });
        }

        if (scheduled > ordered) {
            errors.push({ message: `ITEM ${i + 1}: Scheduled quantity (${scheduled}) cannot exceed ordered quantity (${ordered})` });
        }

        if (status === 5 && received !== ordered) {
            errors.push({ message: `ITEM ${i + 1}: Status cannot be 'RECEIVED' unless full quantity is received` });
        }

        // NEW VALIDATION: Receiving location required for RECEIVED status
        if (status === 5 && (!item.locsub || item.locsub === '')) {
            errors.push({ message: `ITEM ${i + 1}: Receiving location is required for 'RECEIVED' status` });
        }
    }

    return errors;
},



hasItemChanges(item) {
    const changes = [
        item.quantity_received != item.original_quantity_received,
        item.status != item.original_status,
        item.quantity_scheduled != item.original_quantity_scheduled,
        item.fob_price != item.original_fob_price,
        item.landed_cost != item.original_landed_cost,
        item.landed_cost_calculated != item.original_landed_cost_calculated, // Add this line
        item.locsub != item.original_locsub,
        item.schedule_date != item.original_schedule_date,
        item.receiving_date != item.original_receiving_date,
        item.comments != item.original_comments,
        item.color != item.original_color
    ];

    return changes.some(change => change === true);
},

// Helper to get changed items for saving
getChangedItems() {
    return this.items.filter(item => {
        return this.hasItemChanges(item) || !item.hasOwnProperty('original_status');
    }).map(item => {
        return {
            product_sku: item.product_sku,
            quantity_received: item.quantity_received,
            quantity_scheduled: item.quantity_scheduled,
            quantity_ordered: item.quantity_ordered,
            status: item.status,
            fob_price: item.fob_price,
            landed_cost: item.landed_cost,
            landed_cost_calculated: item.landed_cost_calculated, // Make sure this is included
            locsub: item.locsub,
            schedule_date: item.schedule_date,
            receiving_date: item.receiving_date,
            comments: item.comments,
            color: item.color,
            container_order_item_id: item.container_order_item_id || null,
            container_order_id: item.container_order_id
        };
    });
},

hasQuantityChanged(item) {
    return item.quantity_received !== item.original_quantity_received;
},

hasScheduledChanged(item) {
    return item.quantity_scheduled !== item.original_quantity_scheduled;
},

hasStatusChanged(item) {
    return item.status !== item.original_status;
},

// Helper method for item errors
addItemError(itemErrors, index, message) {
    if (!itemErrors[index]) {
        itemErrors[index] = [];
    }
    itemErrors[index].push(message);
},

// Enhanced field-level validation
// validateQuantity(item) {
//     this.$set(item, 'quantityError', null);

//     if (item.quantity_received === null || item.quantity_received === undefined || item.quantity_received === '') {
//         return true;
//     }

//     const received = Number(item.quantity_received);
//     const ordered = Number(item.quantity_ordered);
//     const min = this.getMinQuantity(item);

//     if (isNaN(received)) {
//         this.$set(item, 'quantityError', "Quantity must be a valid number");
//         return false;
//     }

//     if (received < min) {
//         this.$set(item, 'quantityError', `Quantity cannot be less than previously received (${min})`);
//         return false;
//     }

//     if (received > ordered) {
//         this.$set(item, 'quantityError', "Quantity received cannot exceed quantity ordered");
//         return false;
//     }

//     // Validate status consistency
//     if (received > 0) {
//         const status = Number(item.status);
//         if (received === ordered && status !== 5) {
//             this.$set(item, 'quantityError', "Status should be 'RECEIVED' when full quantity is received");
//             return false;
//         }

//         if (received < ordered && status !== 4) {
//             this.$set(item, 'quantityError', "Status should be 'PARTIAL' when partial quantity is received");
//             return false;
//         }
//     }

//     return true;
// },
  validateQuantity(item) {
    this.$set(item, 'quantityError', null);

    // Skip validation if quantity hasn't changed
    if (item.quantity_received === item.original_quantity_received) {
        return true;
    }

    if (item.quantity_received === null || item.quantity_received === undefined || item.quantity_received === '') {
        return true;
    }

    const received = Number(item.quantity_received);
    const ordered = Number(item.quantity_ordered);
    const min = this.getMinQuantity(item);

    if (isNaN(received)) {
        this.$set(item, 'quantityError', "Must be a valid number");
        return false;
    }

    if (received < min) {
        this.$set(item, 'quantityError', `Cannot be less than ${min} (previously received)`);
        return false;
    }

    if (received > ordered) {
        this.$set(item, 'quantityError', `Cannot exceed ordered quantity (${ordered})`);
        return false;
    }

    // Trigger status update based on quantity
    if (!item.manuallyChangingStatus) {
        this.autoUpdateStatusBasedOnQuantity(item);
    }

    return this.validateStatusConsistency(item);
},
validateScheduledQuantity(item) {
    this.$set(item, 'scheduledQuantityError', null);

    if (item.quantity_scheduled === null || item.quantity_scheduled === undefined || item.quantity_scheduled === '') {
        return true;
    }

    const scheduled = Number(item.quantity_scheduled);
    const ordered = Number(item.quantity_ordered);

    if (isNaN(scheduled)) {
        this.$set(item, 'scheduledQuantityError', "Must be a valid number");
        return false;
    }

    if (scheduled < 0) {
        this.$set(item, 'scheduledQuantityError', "Cannot be negative");
        return false;
    }

    if (scheduled > ordered) {
        this.$set(item, 'scheduledQuantityError', `Cannot exceed ordered quantity (${ordered})`);
        return false;
    }

    // Auto-set status to SCHEDULED when quantity is scheduled
    if (scheduled > 0 && item.status !== 3 && item.status !== 5) {
        item.status = 3;
    }
     if (scheduled > 0 && item.status === 3 && (!item.schedule_date || item.schedule_date === null || item.schedule_date === '')) {
        // Set schedule date to current date
        item.schedule_date = moment().format('MM-DD-YYYY');
        item.scheduled_by_final_eta = false; // Not from final ETA
    }

    return true;
},

// // Enhanced save method with comprehensive validation
// save_container_order_items: function () {
//     let data = {
//         container_order_id: this.container_order_id,
//         items: this.items.filter(item => item.original_status !== 5),
//     }

//     if (data.items.length === 0) {
//         this.$bvToast.toast(
//             "No Items to Save or All Items are marked as Received",
//             {title: "No Items to Save", autoHideDelay: 2500, variant:"warning"}
//         );
//         return;
//     }
//     // In your validate method, add this check:
//     if ([4, 5].includes(status) && !item.locsub) {
//         errors.push({
//             message: `ITEM ${i + 1}: RECEIVING LOCATION IS REQUIRED FOR PARTIAL OR RECEIVED STATUS.`
//         });
//     }

//     // Validate all items before saving
//     let hasErrors = false;
//     this.items.forEach(item => {
//         const quantityValid = this.validateQuantity(item);
//         const scheduledValid = this.validateScheduledQuantity(item);

//         if (!quantityValid || !scheduledValid) {
//             hasErrors = true;
//         }
//     });

//     if (hasErrors) {
//         this.$bvToast.toast(
//             "Please fix validation errors before saving",
//             {title: "Validation Error", autoHideDelay: 3000, variant:"danger"}
//         );
//         return;
//     }

//     // Run comprehensive validation
//     let errors = this.validate(data);
//     if (errors.length > 0) {
//         // Show the first error in a toast
//         this.$bvToast.toast(
//             errors[0].message,
//             { title: "Validation Error", autoHideDelay: 5000, variant: "danger" }
//         );

//         // Also show all errors in console for debugging
//         console.error("Validation errors:", errors);
//         return;
//     }

//     // Show confirmation before saving
//     this.modalTitle = 'Confirm Save';
//     this.modalMessage = 'Are you sure you want to save all changes to this container order?';
//     this.confirmationAction = 'save';
//     this.$bvModal.show('confirmation-modal');
// },
// save_container_order_items: function () {
//     let data = {
//         container_order_id: this.container_order_id,
//         items: this.items.filter(item => this.hasItemChanges(item)),
//     }

//     if (data.items.length === 0) {
//         this.$bvToast.toast(
//             "No changes to save",
//             {title: "No Changes", autoHideDelay: 3000, variant:"info"}
//         );
//         return;
//     }
//     if (data.items.length === 0) {
//         this.$bvToast.toast(
//             "All items are marked as received - nothing to save",
//             {title: "No Changes", autoHideDelay: 3000, variant:"info"}
//         );
//         return;
//     }

//     // Validate all items before saving
//     let hasFieldErrors = false;
//     this.items.forEach(item => {
//         const quantityValid = this.validateQuantity(item);
//         const scheduledValid = this.validateScheduledQuantity(item);

//         if (!quantityValid || !scheduledValid) {
//             hasFieldErrors = true;
//         }
//     });

//     if (hasFieldErrors) {
//         this.$bvToast.toast(
//             "Please fix the highlighted validation errors",
//             {title: "Validation Errors", autoHideDelay: 4000, variant:"danger"}
//         );
//         return;
//     }

//     // Run comprehensive validation
//     let errors = this.validate(data);
//     if (errors.length > 0) {
//         // Show the first 3 errors
//         const errorMessages = errors.slice(0, 3).map(e => e.message);

//         this.$bvModal.msgBoxOk(
//             `Please fix the following issues:\n\n• ${errorMessages.join('\n• ')}${errors.length > 3 ? '\n\n...and ' + (errors.length - 3) + ' more issues' : ''}`,
//             {
//                 title: 'Validation Failed',
//                 size: 'lg',
//                 headerBgVariant: 'danger',
//                 headerTextVariant: 'light'
//             }
//         );
//         return;
//     }

//     // Show confirmation with summary
//     const modifiedItems = data.items.filter(item =>
//         item.quantity_received !== item.original_quantity_received ||
//         item.status !== item.original_status
//     ).length;

//     this.modalTitle = 'Confirm Changes';
//     this.modalMessage = `Save changes to ${modifiedItems} item(s)?`;
//     this.confirmationAction = 'save';
//     this.$bvModal.show('confirmation-modal');
// },

save_container_order_items: function () {
    const changedItems = this.getChangedItems();

    if (changedItems.length === 0) {
        this.$bvToast.toast(
            "No changes to save",
            {title: "No Changes", autoHideDelay: 3000, variant:"info"}
        );
        return;
    }

    let data = {
        container_order_id: this.container_order_id,
        items: changedItems,
        created_by: this.packet.userDetails.username,
        location_id: this.packet.userDetails.properties.location_id,

    }

    console.log("Saving data:", JSON.stringify(data, null, 2));

    // Run simplified validation
    let errors = this.validate(data);
    if (errors.length > 0) {
        this.$bvModal.msgBoxOk(
            `Please fix the following issues:\n\n• ${errors.map(e => e.message).join('\n• ')}`,
            {
                title: 'Validation Failed',
                size: 'lg',
                headerBgVariant: 'danger',
                headerTextVariant: 'light'
            }
        );
        return;
    }
      let hasFobErrors = false;
        this.items.forEach(item => {
            if (item.status === 3 && !this.validateFobPrice(item)) {
                hasFobErrors = true;
            }
        });

        if (hasFobErrors) {
            this.$bvToast.toast(
                "Please fix FOB price validation errors before saving",
                {title: "Validation Error", autoHideDelay: 3000, variant:"danger"}
            );
            return;
        }

    // Show confirmation
    this.modalTitle = 'Confirm Changes';
    this.modalMessage = `Save changes to ${changedItems.length} item(s)?`;
    this.confirmationAction = 'save';
    this.$bvModal.show('confirmation-modal');
},


// Update the handleConfirmation method
handleConfirmation() {
    switch (this.confirmationAction) {
        case 'save':
            this.executeSave();
            break;
        case 'remove':
            this.executeDelete(this.confirmationData);
            break;
    }

    // Reset confirmation data
    this.confirmationAction = null;
    this.confirmationData = null;
},

executeDelete(item) {
    if (!item.container_order_item_id) {
        this.$bvToast.toast(
            "Item ID is missing - cannot delete",
            { title: "Error", autoHideDelay: 3000, variant: "danger" }
        );
        return;
    }

    let data = {
        container_order_item_id: item.container_order_item_id
    };

    let that = this;
    let path = "/api/vendor/delete_container_order_item/";

    let s = function(response) {
        if (response.data.error) {
            that.$bvToast.toast(
                response.data.error,
                { title: "Error", autoHideDelay: 3000, variant: "warning" }
            );
        } else {
            that.$bvToast.toast(
                "Item removed successfully",
                { title: "Success", autoHideDelay: 2000, variant: "success" }
            );
            
            // Remove the item from the local array
            that.items = that.items.filter(d => d.product_sku !== item.product_sku);
        }
    };

    let f = function(error) {
        console.log("Delete error:", error);
        that.$bvToast.toast(
            "Error occurred while deleting item",
            { title: "Error", autoHideDelay: 3000, variant: "danger" }
        );
    };

    Requestor.postSyncP(path, data, this, s, f);
},
// Separate method for actual saving
executeSave() {
    const changedItems = this.getChangedItems();

    let data = {
        container_order_id: this.container_order_id,
        items: changedItems,
        created_by: this.packet.userDetails.username,
        location_id: this.packet.userDetails.properties.location_id
    };

    console.log("Sending to server:", JSON.stringify(data, null, 2));

    let that = this;
    let path = "/api/vendor/save_container_order_items/";

    let s = function (response) {
        if (response.data.error) {
            that.$bvToast.toast(
                response.data.error,
                { title: "Error", autoHideDelay: 1500, variant: "warning" }
            );
        } else {
            that.$bvToast.toast(
                "Changes saved successfully",
                { title: "Success", autoHideDelay: 1500, variant: "success" }
            );

            // Update original values after successful save
            that.items.forEach(item => {
                if (that.hasItemChanges(item)) {
                    that.$set(item, 'original_quantity_received', item.quantity_received);
                    that.$set(item, 'original_status', item.status);
                    that.$set(item, 'original_quantity_scheduled', item.quantity_scheduled);
                    that.$set(item, 'original_fob_price', item.fob_price);
                    that.$set(item, 'original_landed_cost', item.landed_cost);
                    that.$set(item, 'original_locsub', item.locsub);
                    that.$set(item, 'original_schedule_date', item.schedule_date);
                    that.$set(item, 'original_receiving_date', item.receiving_date);
                    that.$set(item, 'original_comments', item.comments);
                    that.$set(item, 'original_color', item.color);
                }
            });
        }
        that.loading = false;
    };

    let f = function (error) {
        console.log("Save error:", error);
        that.$bvToast.toast(
            "Error occurred. Please try again.",
            { title: "Error", autoHideDelay: 1500, variant: "danger" }
        );
        that.loading = false;
    };

    this.loading = true;
    Requestor.postSyncP(path, data, this, s, f);
},
        preventInvalidEntry(event, item) {
            // Allow backspace, delete, tab, etc.
            const allowedKeys = [8, 9, 13, 37, 38, 39, 40, 46];
            if (allowedKeys.includes(event.keyCode)) return;

            // Get current value without the changed character
            const currentValue = event.target.value;
            const newValue = currentValue.slice(0, event.target.selectionStart) +
                currentValue.slice(event.target.selectionEnd);

            // Get min and max values
            const min = this.getMinQuantity(item);
            const max = item.quantity_ordered;

            // Prevent typing if the new value would be invalid
            if (newValue !== '' && (isNaN(newValue) ||
                parseInt(newValue) < min ||
                parseInt(newValue) > max)) {
                event.preventDefault();
            }
        },
        isItemDisabled(item) {
    // Allow admin to edit received items, but restrict certain fields
    if (item.original_status === 5) {
        return this.packet.userDetails.userrole !== 'admin';
    }
    return item.receiving_date_disabled;
},
isItemDisabled2(item)
{
     const completedStatuses = [6,7]; //  COMPLETED, ARCHIVED

    if (this.packet.userDetails.userrole !== 'admin') {
        return true;
    }

    if (completedStatuses.includes(item.original_status)) {
        return true;
    }
},
        getMinQuantity(item) {
            // Return the previously received quantity as minimum
            // If this is a new item, minimum is 0
            return item.original_quantity_received || 0;
        },
        getMinScheduledQuantity(item) {
          if (item.status == 3) {
            return 1;
          }
          return 0;
        },
//       handleStatusChange(item) {
//     // If status set to Received, validate receiving location first
//     if (item.status === 5) {
//         if (!item.locsub) {
//             this.$bvToast.toast(
//                 "Please select a receiving location before marking as received",
//                 { title: "Validation Error", autoHideDelay: 3000, variant: "danger" }
//             );
//             // Revert status back to previous value
//             this.$nextTick(() => {
//                 item.status = item.original_status || 1;
//             });
//             return;
//         }

//         item.quantity_received = item.quantity_ordered;
//         item.receiving_date = moment().format('MM-DD-YYYY');
//         // Disable the receiving date field
//         this.$set(item, 'receiving_date_disabled', true);
//     }
//     // If status set to Partial but no quantity received, set to min
//     else if (item.status === 4 && item.quantity_received === 0) {
//         item.quantity_received = this.getMinQuantity(item) || 1;
//         // Re-enable receiving date if not Received
//         this.$set(item, 'receiving_date_disabled', false);
//     }
//     else {
//         // For all other status changes, re-enable receiving date
//         this.$set(item, 'receiving_date_disabled', false);
//     }

//     if (item.status === 3 && item.quantity_scheduled < 1) {
//         item.quantity_scheduled = 1;
//     }

//     if (item.original_status === 5 && item.status !== 5) {
//         item.receiving_date = null;
//     }

//     // Store the current status as original_status for future reference
//     if (!item.original_status) {
//         this.$set(item, 'original_status', item.status);
//     }
// },
handleStatusChange(item) {
    // Set flag to prevent auto-update during manual status change
     item.manuallyChangingStatus = true;

    // Check if trying to set to RECEIVED without receiving location
    if (item.status === 5 && (!item.locsub || item.locsub === '')) {
        this.$bvToast.toast(
            "Select receiving location first",
            { title: "Required", autoHideDelay: 3000, variant: "danger" }
        );

        // Revert to previous status
        this.$nextTick(() => {
            item.status = item.original_status || 1;
            item.manuallyChangingStatus = false;
        });
        return;
    }

    if (item.status === 3 && (!item.schedule_date || item.schedule_date === null || item.schedule_date === '')) {
        item.schedule_date = moment().format('MM-DD-YYYY');
        item.scheduled_by_final_eta = false;
    }

    if (item.status === 3) {
        if (!this.validateFobPriceForScheduled(item)) {
            this.$nextTick(() => {
                item.status = item.original_status || 1;
                item.manuallyChangingStatus = false;
            });
            return;
        }
    }

      if (item.original_status === 5 && this.packet.userDetails.userrole !== 'admin') {
        this.$nextTick(() => {
            item.status = 5; // Revert to received
        });
        this.$bvToast.toast(
            "Only admins can modify status of received items",
            { title: "Restricted", autoHideDelay: 3000, variant: "warning" }
        );
        return;
    }
    // Prevent status change for received items

    const status = Number(item.status);

    // Received status validation
    if (status === 5) {
        if (!item.locsub) {
            this.$bvToast.toast(
                "Select receiving location first",
                { title: "Required", autoHideDelay: 3000, variant: "danger" }
            );
            this.$nextTick(() => { item.status = item.original_status || 1; });
            return;
        }

        item.quantity_received = item.quantity_ordered;
        item.receiving_date = moment().format('MM-DD-YYYY');
        item.receiving_date_disabled = true;
    }
    // Partial status validation
    else if (status === 4) {
        if (item.quantity_received === 0) {
            item.quantity_received = Math.max(1, this.getMinQuantity(item));
        }
        item.receiving_date_disabled = false;
    }
    // Scheduled status validation
    else if (status === 3) {
        if (!item.quantity_scheduled || item.quantity_scheduled === 0) {
            item.quantity_scheduled = 1;
        }
        if (!item.schedule_date) {
            item.schedule_date = this.mainScheduleDate || moment().format('MM-DD-YYYY');
        }
        item.receiving_date_disabled = false;
    }
    else {
        item.receiving_date_disabled = false;
    }

    // Store original status if not set
    if (!item.original_status) {
        this.$set(item, 'original_status', item.status);
    }
     if ([1, 2].includes(status)) {
            this.applyDefaultSettings(item);
        }
},
        getStatusState(item) {
            if (item.quantity_received > 0) {
                return [4, 5].includes(item.status) ? null : false;
            }
            return null;
        },
        add_custom_item: function (e) {

            let idx = this.items.length;
            let item = {
                idx: idx + 1,
                product_sku: null,
                product_name: null,
                category_id: null,
                vendor_id: this.vendor_id,
                cubes: null,
                quantity: null,
                fob_price: null,
                selling_price: null,
                landed_cost: null,
                landed_cost_calculated:null,
                wholesale_price: null,
                product_type: 2,
                receiving_location_id: null,
                receiving_sublocation_id: null,
                original_quantity_received: null,
                original_status: null,
                created_by: this.packet.userDetails.username,
            }

            this.items.push(item);
            return
        },
add_item: function (e) {
    if (this.items.filter(function (d) { return d.product_sku == e.product_sku }).length > 0) {
        this.$bvToast.toast(
            "This product is already in the order",
            { title: "Duplicate Product", autoHideDelay: 3000, variant: "warning" }
        );
        return;
    }

    let idx = this.items.length;

    // Get default location - ensure it's one of the 40| sub-locations
    let defaultSubLocation = this.getDefaultReceivingLocation();

    // If still no location found, manually create one based on receiving_location_id
    if (!defaultSubLocation && this.receiving_location_id) {
        // Create a default sub-location ID like "40|1"
        defaultSubLocation = this.receiving_location_id + '|1';
        console.log("Created default location:", defaultSubLocation);
    }

    console.log("Adding item with location:", defaultSubLocation);

    // Calculate initial landed_cost_calculated based on FOB price
   let fobPrice = e.fob_price ? parseFloat(e.fob_price) : 0;
    let landedCostCalculated = fobPrice; // Start with FOB price

    // Calculate landed cost using the same method as backend
    if (this.items.length > 0) {
        this.calculateLandedCostForNewItem({ fob_price: fobPrice }, landedCostCalculated);
    } else {
        // Use default calculation for first item
        const tariff = parseFloat(this.tariff) || 0;
        const transport = parseFloat(this.transport) || 0;
        const otherCost = parseFloat(this.other_cost) || 0;
        const invoiceTotal = parseFloat(this.invoice_total) || 0;

        if (invoiceTotal > 0 && fobPrice > 0) {
            const totalAdditionalCosts = tariff + transport + otherCost;
            const costRatio = totalAdditionalCosts / invoiceTotal;
            landedCostCalculated = fobPrice + (fobPrice * costRatio);
        }
    }

    let item = {
        idx: idx + 1,
        product_sku: e.product_sku,
        product_name: e.product_name,
        category_id: e.category_id,
        vendor_id: e.vendor_id,
        cubes: e.cubes,
        quantity_ordered: 1,
        quantity_scheduled: 0,
        quantity_received: 0,
        original_quantity_received: e.quantity_received,
        locsub: defaultSubLocation,
        fob_price: fobPrice,
        selling_price: e.selling_price,
        landed_cost: e.landed_cost,
        landed_cost_calculated: landedCostCalculated, // Use calculated value instead of null
        wholesale_price: e.wholesale_price,
        product_type: e.product_type,
        pictures: [],
        receiving_date: null,
        schedule_date: this.final_eta,
        color: null,
        container_order_id: this.container_order_id,
        original_status: e.status,
        status: 1,
        scheduled_by_final_eta: !!this.final_eta,
        original_locsub: defaultSubLocation,
        original_landed_cost_calculated: landedCostCalculated // Store original for change detection
    }

    this.items.push(item);

    // Show success message with the applied location
    if (defaultSubLocation) {
        const locationObj = this.packet.locsubs.find(function(loc) {
            return loc.value === defaultSubLocation;
        });
        const locationName = locationObj ? locationObj.text : defaultSubLocation;
        this.$bvToast.toast(
            "Added " + e.product_sku + " with location: " + locationName,
            { title: "Item Added", autoHideDelay: 2000, variant: "success" }
        );
    }

    this.product_search_keyword = '';
},
calculateLandedCostForNewItem(itemData, currentLandedCost) {
    const sampleItem = this.items[0];
    if (sampleItem && sampleItem.fob_price && sampleItem.landed_cost_calculated) {
        const ratio = sampleItem.landed_cost_calculated / sampleItem.fob_price;
        currentLandedCost = itemData.fob_price * ratio;
    }
    return currentLandedCost;
},
        remove_item: function (product_sku) {
            this.items = this.items.filter(function (d) { return d.product_sku != product_sku });
            return
        },
        filter_products: function (item, query) {
            return (
                item.product_name.toLowerCase().indexOf(query.toLowerCase()) > -1
                ||
                item.product_sku.toLowerCase().indexOf(query.toLowerCase()) > -1
            )
        },
//         fetch_init: function () {
//            let data = { container_order_id: this.container_order_id }
//     let path = "/api/vendor/get_container_order_items/"
//     let that = this;
//     let s = function (response) {
//         if (response.data.error) {
//             // error handling
//         } else {
//             // Check if we have items and extract final_eta from the first item
//             if (response.data.result && response.data.result.length > 0) {
//                 // Get final_eta from the first item (assuming all items have the same final_eta)
//                 that.final_eta = response.data.result[0].final_eta;
//                 console.log("Extracted final_eta from API:", that.final_eta);
//             }

//             that.items = response.data.result.map(item => {
//                 // Store original values for all fields
//                 const newItem = {
//                     ...item,
//                     original_status: item.status,
//                     original_quantity_received: item.quantity_received,
//                     original_quantity_scheduled: item.quantity_scheduled,
//                     original_locsub: item.locsub,
//                     original_scheduled_date: item.scheduled_date,
//                     original_receiving_date: item.receiving_date,
//                     scheduled_date_set: false // Reset this flag
//                 };

//                 // Apply defaults to newly loaded items
//                 if ([1, 2].includes(newItem.status) && newItem.status !== 3) {
//                     that.applyDefaultSettings(newItem);
//                     newItem.scheduled_date_set = true;
//                 }

//                 return newItem;
//             });
//         }
//         that.loading = false;
//     }
//     let f = function (error) {
//         that.$bvToast.toast(
//             "Error retrieving products.",
//             { title: "Error", autoHideDelay: 1500, variant: "danger" }
//         );
//         that.loading = false;
//     }
//     this.loading = true;
//     Requestor.getSyncP(path, data, this, s, f);
// },
fetch_init: function () {
    let data = { container_order_id: this.container_order_id }
    let path = "/api/vendor/get_container_order_items/"
    let that = this;
    let s = function (response) {
        if (response.data.error) {
            // error handling
        } else {
            that.receiving_location_id = response.data.creceiving_location;
            that.final_eta = response.data.final_eta;

            console.log("Container Order Data:", {
                receiving_location_id: that.receiving_location_id,
                final_eta: that.final_eta,
                fullResponse: response.data
            });

            that.items = response.data.result.map(item => {
                // Store ALL original values for change detection
                const newItem = {
                    ...item,
                    container_order_item_id: item.container_order_item_id || item.id, // Make sure this is included
                    original_status: item.status,
                    original_quantity_received: item.quantity_received,
                    original_quantity_scheduled: item.quantity_scheduled,
                    original_fob_price: item.fob_price,
                    original_landed_cost: item.landed_cost,
                    original_landed_cost_calculated: item.landed_cost_calculated,
                    original_locsub: item.locsub,
                    original_schedule_date: item.schedule_date,
                    original_receiving_date: item.receiving_date,
                    original_comments: item.comments,
                    original_color: item.color,
                    scheduled_date_set: false
                };

                // Debug: Log the item ID
                console.log("Item loaded:", item.product_sku, "ID:", newItem.container_order_item_id);

                // Apply default location if locsub is not set
                if (!newItem.locsub && that.receiving_location_id) {
                    const defaultLocation = that.getDefaultReceivingLocation();
                    if (defaultLocation) {
                        newItem.locsub = defaultLocation;
                        newItem.original_locsub = defaultLocation;
                    }
                }

                return newItem;
            });
        }
        that.loading = false;
    }
    let f = function (error) {
        that.$bvToast.toast(
            "Error retrieving products.",
            { title: "Error", autoHideDelay: 1500, variant: "danger" }
        );
        that.loading = false;
    }
    this.loading = true;
    Requestor.getSyncP(path, data, this, s, f);
},
      fetch_prereqs: function () {
            // Add guard to prevent multiple calls
            if (this._prereqsLoading) return;
            this._prereqsLoading = true;

            let data = {}
            let path = "/api/product/get_product_list_v5/"
            let that = this;
            let s = function (response) {
                that._prereqsLoading = false;
                if (response.data.error) {
                    that.$bvToast.toast(
                        "ERROR RETRIEVING PRODUCT LIST",
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                }
                else {
                    that.products = response.data.result;
                    that.products = that.products.filter(function (d) {
                        return d.vendor_id == that.container_order_vendor_id
                    });
                    that.fetch_init();
                }
                that.loading = false;
            }

            let f = function (error) {
                that._prereqsLoading = false;
                that.$bvToast.toast(
                    "Error retrieving products.",
                    { title: "Error", autoHideDelay: 1500, variant: "danger" }
                );
                that.loading = false;
            }
            this.loading = true;
            Requestor.getSyncP(path, data, this, s, f);
        },
        filter_products_for_vendor: function () {
            // if (e){
            //     e.preventDefault();
            // }
            let that = this;
            this.vendor_products = this.products.filter(function (d) { return d.vendor_id == that.vendor_id });
        },
        close_it: function () {
            this.$emit("done-items-co", this.items);
        }
    },
    computed: {
       filteredLocations() {
    if (!this.receiving_location_id || !this.packet.locsubs) {
        return this.packet.locsubs || [];
    }

    const receivingLoc = this.receiving_location_id.toString();
    console.log(`Filtering locations for: ${receivingLoc}`);

    const filtered = this.packet.locsubs.filter(loc => {
        const locValue = loc.value.toString();
        // Only show locations that start with "40|" (sub-locations of 40)
        return locValue.startsWith(receivingLoc + '|');
    });

    console.log("Filtered sub-locations:", filtered);
    return filtered;
},
         isFobPriceRequired() {
        return (status) => status === 3; // Required for SCHEDULED status
    },
        coloredStatuses() {
            const colors = this.statusColors();
            return this.statuses.map(status => ({
                ...status,
                style: {
                    backgroundColor: colors[status.value],
                    color: this.getTextColor(colors[status.value])
                }
            }));
        }
    },
     watch: {

          items: {
            handler(newItems) {
                // Remove the nested watcher creation from here
                // Handle item changes without creating new watchers
                newItems.forEach((item, index) => {
                    if (item.schedule_date && this.final_eta) {
                        if (item.schedule_date !== this.final_eta) {
                            item.scheduled_by_final_eta = false;
                        } else {
                            item.scheduled_by_final_eta = true;
                        }
                    }
                });
            },
            deep: true
            // Remove immediate: true
        },

        mainScheduleDate(newDate) {
            if (newDate && this.autoApplyMainDate) {
                this.applyMainScheduleDate();
            }
        },

        mainReceivingLocation(newLocation) {
            if (newLocation && this.autoApplyMainReceivingLocation) {
                this.applyMainReceivingLocation();
            }
        },

        container_order_id: function(newVal) {
            if (newVal) {
                this.fetchContainerOrderHistory();
            }
        },
    },
   mounted: function () {
    this.fetch_prereqs();
    if (this.container_order_id) {
        this.fetchContainerOrderHistory();
    }

    // Debug: Check what locations are available
    this.$nextTick(() => {
        console.log("Component mounted - available locations:", this.packet.locsubs);
        console.log("Receiving location ID:", this.receiving_location_id);
        console.log("Filtered locations:", this.filteredLocations);
    });
},
      created: function () {
        this.packet = JSON.parse(localStorage.packet);
        this.packet.userDetails = JSON.parse(localStorage.userDetails);
        this.container_order_id = JSON.parse(JSON.stringify(this.viewdata)).container_order_id;
        this.container_order_vendor_id = JSON.parse(JSON.stringify(this.viewdata)).container_order_vendor_id;
        this.read_only = JSON.parse(JSON.stringify(this.viewdata)).read_only;
        this.final_eta = JSON.parse(JSON.stringify(this.viewdata)).final_eta ||
                       JSON.parse(JSON.stringify(this.viewdata)).requested_eta ||
                       JSON.parse(JSON.stringify(this.viewdata)).eta;

        if (this.packet.userDetails && this.packet.userDetails.properties) {
            this.receiving_location_id = this.packet.userDetails.properties.location_id;
        }

        this.mainReceivingLocation = this.getDefaultReceivingLocation();

        if (this.read_only != true) {
            this.fetch_prereqs(); // Only call once here
        }
    }
}


</script>


<style scoped>
.input-field {
  width: 500px;
}

::v-deep .custom-select {
  background-image: none;
}

/* Style the dropdown options */
::v-deep .custom-select option {
  padding: 8px;
  font-size: 11px;
}

.date .input-group-text {
  padding: 0;
  padding-left: 10px;
  padding-right: 10px;
}

.diver {
  overflow: auto;
  width: 100%;
  padding-bottom: 20px;
  position: relative;
}

/* Table styling for sticky columns */
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.srr {
  font-size: 11px;
  text-align: center;
  background: #efefef;
  border: 1px solid #010101;
}

.srrv {
  font-size: 11px;
  text-align: center;
  background: white;
  border: 1px solid #010101;
  padding: 5px;
}

/* ============================================ */
/* STICKY COLUMNS: Freeze first 2 columns       */
/* ============================================ */

/* First column (PRODUCT SKU) - Sticky */
.srrv:first-of-type,
thead .srr:first-of-type {
  position: sticky;
  left: 0;
  background-color: white;
  z-index: 1;
}

/* Header first column needs higher z-index */
thead .srr:first-of-type {
  background-color: #efefef;
  z-index: 3;
}

/* Second column (DESCRIPTION) - Sticky, positioned after first column */
.srrv:nth-of-type(2),
thead .srr:nth-of-type(2) {
  position: sticky;
  left: 100px; /* Width of first column */
  background-color: white;
  z-index: 2;
}

/* Header second column */
thead .srr:nth-of-type(2) {
  background-color: #efefef;
  z-index: 3;
}

/* Ensure body rows have proper background for sticky columns */
tbody tr .srrv:first-of-type,
tbody tr .srrv:nth-of-type(2) {
  background-color: white;
}

/* Optional: Add shadow effect for visual separation */
.srrv:first-of-type,
.srrv:nth-of-type(2),
thead .srr:first-of-type,
thead .srr:nth-of-type(2) {
  box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.15);
}

/* Remove shadow from last row to avoid overflow issues */
tbody tr:last-child .srrv:first-of-type,
tbody tr:last-child .srrv:nth-of-type(2) {
  box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.1);
}

/* ============================================ */
/* END OF STICKY COLUMNS                        */
/* ============================================ */

.modal-xl {
  min-width: 1000px !important;
}

.mx-input {
  font-size: 12px;
}

.schedule-date-picker {
  width: 150px;
}

.receiving-location-picker {
  width: 200px;
}

/* Status color styles */
.status-new { background-color: #f8f9fa; color: black; }
.status-ordered { background-color: #e3f2fd; color: black; }
.status-scheduled { background-color: #e1f5fe; color: black; }
.status-in-transit { background-color: #fff3e0; color: black; }
.status-partial { background-color: #fff9c4; color: black; }
.status-received { background-color: #c8e6c9; color: black; }
.status-completed { background-color: #1b5e20; color: white; }
.status-archived { background-color: #f5f5f5; color: black; }

/* Responsive styles */
@media screen and (max-width: 768px) {
  .input-field {
    width: 100%;
  }

  .schedule-date-picker,
  .receiving-location-picker {
    width: auto;
  }

  .diver {
    height: auto;
    overflow-x: auto;
    overflow-y: auto;
  }

  /* Adjust sticky columns for mobile */
  .srrv:first-of-type,
  .srrv:nth-of-type(2),
  thead .srr:first-of-type,
  thead .srr:nth-of-type(2) {
    box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.2);
  }
}

/* Print styles - disable sticky for printing */
@media print {
  .srrv:first-of-type,
  .srrv:nth-of-type(2),
  thead .srr:first-of-type,
  thead .srr:nth-of-type(2) {
    position: static;
    box-shadow: none;
  }
  
  .diver {
    overflow: visible;
  }
}

/* Validation error styles */
.has-error .b-form-input,
.is-invalid {
  border-color: #dc3545;
  background-color: #fff8f8;
}

.invalid-feedback,
.b-form-invalid-feedback {
  color: #dc3545;
  font-size: 10px;
  margin-top: 2px;
}

/* Input focus styles */
.b-form-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Button group spacing */
.btn-group-sm > .btn,
.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

/* Image thumbnail styles */
.img-thumbnail {
  padding: 2px;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 40px;
  max-height: 40px;
}

/* Toast customization */
.toast {
  font-size: 12px;
}

/* Date picker customization */
.mx-datepicker {
  width: 100%;
}

.mx-input-wrapper .mx-input {
  padding: 4px 8px;
  font-size: 11px;
  height: auto;
}

/* Select dropdown customization */
.custom-select-sm {
  font-size: 11px;
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 1.5rem 0.25rem 0.5rem;
}

/* Loading overlay customization */
.vld-overlay {
  background: rgba(255, 255, 255, 0.7);
}

.vld-icon {
  color: #007bff;
}

/* Badge styles */
.badge-info {
  background-color: #17a2b8;
  color: white;
  font-size: 9px;
  padding: 2px 4px;
}

/* Alert styles */
.alert {
  padding: 0.5rem 0.75rem;
  font-size: 12px;
  margin-bottom: 10px;
}

/* Card header styles */
.card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  padding: 0.5rem 1rem;
}

/* Flex gap utility */
.gap-3 {
  gap: 1rem;
}

/* Background colors */
.bg-light {
  background-color: #f8f9fa !important;
}

/* Text colors */
.text-nowrap {
  white-space: nowrap;
}

/* Margin utilities */
.mb-0 {
  margin-bottom: 0 !important;
}
.mr-2 {
  margin-right: 0.5rem !important;
}
.ml-2 {
  margin-left: 0.5rem !important;
}
.mt-1 {
  margin-top: 0.25rem !important;
}
.ml-0 {
  margin-left: 0 !important;
}

/* Padding utilities */
.p-2 {
  padding: 0.5rem !important;
}
.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

/* Flex utilities */
.d-flex {
  display: flex !important;
}
.justify-content-start {
  justify-content: flex-start !important;
}
.justify-content-between {
  justify-content: space-between !important;
}
.align-items-center {
  align-items: center !important;
}
.flex-wrap {
  flex-wrap: wrap !important;
}

/* Responsive flex utilities */
@media (min-width: 992px) {
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VendorOrders/ContainerOrderItems.vue